import React from "react";
import { PeekBox } from "@piiqtechnologies/ui-components";
export const WhiskerConnector = ({ side }) => (React.createElement(PeekBox, { sx: {
        width: 16,
        height: 2,
        bgcolor: "grey.400",
        position: "relative",
        "&::after": {
            content: '""',
            position: "absolute",
            top: "50%",
            [side === "left" ? "left" : "right"]: 0,
            transform: "translateY(-50%)",
            width: 2,
            height: 16,
            bgcolor: "grey.400",
        },
    } }));
export default WhiskerConnector;
